import socialUtils from "@/utils/social.utils";

class SharingService {

  sharing(socialNetwork: string, url: string, title: string, description: string) {
    try {
        socialNetwork = socialNetwork.toLowerCase();
        if (socialNetwork in socialUtils && socialUtils[socialNetwork]) {
          let shareUrl = socialUtils[socialNetwork];
          shareUrl = shareUrl.replaceAll("@u", encodeURIComponent(this.redirectTo(url)));
          shareUrl = shareUrl.replaceAll("@t", encodeURIComponent(title));
          shareUrl = shareUrl.replaceAll("@d", encodeURIComponent(description));
          shareUrl = shareUrl.replaceAll("@q", encodeURIComponent("quaote text"));
          shareUrl = shareUrl.replaceAll("@h", encodeURIComponent("#linksdigest"));
          shareUrl = shareUrl.replaceAll("@l", encodeURIComponent(url));
          return shareUrl;
        }
       return "";
    } catch (error) {
      console.error("Error fetching links:", error);
      throw error;
    }    
  }

  redirectTo(url: string) {
    return window.location.origin + '/redirect/'+encodeURIComponent(url)
  }
}

export default new SharingService();